<template>
    <div>
        <NuxtLayout name="mapa">
            <iframe
                ref="iframe"
                :src="appUrl"
                class="h-full w-full md:rounded-md md:shadow-md"
            />
        </NuxtLayout>
    </div>
</template>

<script lang="ts" setup>
const { locale, t } = useI18n()
useSeoMeta({
    title: "pages.atlas",
    ogTitle: () => `${t("pages.atlas")} | %siteName`,
})
const router = useRouter()
const route = useRoute()

const ROOT_APP_URL = "https://app.iprpraha.cz"
//const ROOT_APP_URL = "https://app.iprpraha.cz/apl/app/atlas-uap/"
const APP_URL = `${ROOT_APP_URL}/apl/app/atlas-uap/`

const appUrl = computed(() => {
    if (locale.value === "cs") {
        return APP_URL + window.location.search
    }
    if (window.location.search) {
        return `${APP_URL}${window.location.search}&lang=${locale.value}`
    }
    return `${APP_URL}?lang=${locale.value}`
})

const iframe = useTemplateRef("iframe")

onMounted(() => {
    // Listen for messages from the iframe
    window.addEventListener("message", async event => {
        // Optionally, verify the origin of the message for security
        if (event.origin !== ROOT_APP_URL) return

        const message = event.data
        if (message.type === "send-url-params" && message.data) {
            // console.log("Received data from iframe:", message.data)
            const params: Record<string, string> = {}
            const urlParams = (message.data as string).split("?")[1]?.split("&")
            urlParams?.forEach(param => {
                const [key, value] = param.split("=")
                if (key && value) {
                    params[key] = decodeURIComponent(value)
                }
            })

            router.push({
                path: route.path,
                query: params,
            })
        } else if (message.type === "copyToClipboard") {
            try {
                await navigator.clipboard.writeText(window.location.href)
                iframe.value?.contentWindow?.postMessage(
                    {
                        type: "copyToClipboardSuccess",
                        data: "URL copied to clipboard",
                    },
                    "*"
                )
            } catch (err) {
                console.error("Failed to copy text: ", err)
                iframe.value?.contentWindow?.postMessage(
                    {
                        type: "copyToClipboardError",
                        data: err,
                    },
                    "*"
                )
            }
        } else if (message.type === "resetApp") {
            const url =
                locale.value === "cs"
                    ? APP_URL
                    : `${APP_URL}?lang=${locale.value}`
            if (iframe.value) {
                iframe.value.src = url
                router.push({
                    path: route.path,
                })
            }
        }
    })
})
</script>

<style></style>
